module.exports = __webpack_public_path__ + "img/printbutton-green.ff9dd604.svg";